'use client'

import { useEffect, useState, useRef } from 'react'
import Image from 'next/image'

export function VideoBackground() {
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false)
  const [shouldLoadFallback, setShouldLoadFallback] = useState(false)
  const [isSafari, setIsSafari] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // Check if Safari
    const checkSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    setIsSafari(checkSafari)
    
    // Only load media when it's in viewport using Intersection Observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (checkSafari) {
              setShouldLoadFallback(true)
            } else {
              setShouldLoadVideo(true)
            }
            observer.disconnect()
          }
        })
      },
      { threshold: 0.1 }
    )
    
    if (containerRef.current) {
      observer.observe(containerRef.current)
    }
    
    return () => observer.disconnect()
  }, [])

  return (
    <div ref={containerRef} className="absolute inset-0 z-0 overflow-hidden">
      {/* Placeholder background image while loading */}
      <Image
        src="/images/tour dewey az model homes.webp"
        alt="Tour Dewey AZ Model Homes"
        fill
        priority={true}
        quality={90}
        className="object-cover"
      />
      
      {/* YouTube Video Embed - Only loads when visible and not Safari */}
      {shouldLoadVideo && (
        <iframe
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          style={{ width: '177.77vh', height: '100vh', minWidth: '100%', minHeight: '100%' }}
          src="https://www.youtube-nocookie.com/embed/FuuKz2-T-nE?autoplay=1&mute=1&loop=1&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1&disablekb=1&fs=0&origin=https://fastaffordablehomes.com&playlist=FuuKz2-T-nE"
          title="Manufactured Home Model Video"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen={false}
          loading="lazy"
          sandbox="allow-same-origin allow-scripts"
        />
      )}
      
      {/* For Safari - Just use the placeholder that's already loaded */}
      
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60"></div>
    </div>
  )
}